export const FETCH_DASHBOARD_INIT = "FETCH_DASHBOARD_INIT";

export const FETCH_DASHBOARD_ALL_RESERVATIONS = {
  START: "FETCH_DASHBOARD_ALL_RESERVATIONS.START",
  SUCCESS: "FETCH_DASHBOARD_ALL_RESERVATIONS.SUCCESS",
  ERROR: "FETCH_DASHBOARD_ALL_RESERVATIONS.ERROR",
};

export const TOAST = "TOAST";

export const FETCH_DASHBOARD_DETAILS = {
  START: "FETCH_DASHBOARD_DETAILS_START",
  SUCCESS: "FETCH_DASHBOARD_DETAILS_SUCCESS",
  ERROR: "FETCH_DASHBOARD_DETAILS_ERROR",
};

export const FETCH_V4_DASHBOARD = {
  START: "FETCH_V4_DASHBOARD_START",
  SUCCESS: "FETCH_V4_DASHBOARD_SUCCESS",
  ERROR: "FETCH_V4_DASHBOARD_ERROR",
};

export const SET_DASHBOARD_LOCATIONS = "SET_DASHBOARD_LOCATIONS";
